/**
 * 复制文本到剪贴板（任务 11b）。
 * 主路径 navigator.clipboard.writeText（需 secure context + 用户手势）；
 * http 部署 / 旧 WebView 没有 clipboard API 时降级 execCommand('copy')
 * （隐藏 textarea 选中后复制，微信内置 X5 实测仍走得通的老路径）。
 */
export async function copyText(text: string): Promise<boolean> {
  if (typeof navigator !== 'undefined' && navigator.clipboard !== undefined) {
    try {
      await navigator.clipboard.writeText(text);
      return true;
    } catch {
      // 权限被拒/非安全上下文：落到降级路径
    }
  }
  const ta = document.createElement('textarea');
  ta.value = text;
  ta.setAttribute('readonly', '');
  ta.style.position = 'fixed';
  ta.style.left = '-9999px';
  document.body.appendChild(ta);
  ta.select();
  let ok = false;
  try {
    ok = document.execCommand('copy');
  } catch {
    ok = false;
  }
  ta.remove();
  return ok;
}
